// extracted by mini-css-extract-plugin
export default {"list":"ProductTags_list__hIn1m","badge":"ProductTags_badge__2QaJ-","sm":"ProductTags_sm__-Ef0f","lg":"ProductTags_lg__qJ+Uy"};